import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import moment, { Moment } from 'moment';
import { DatePicker } from 'ant-design-vue';
import TreeMenu from '@/components/common/Tree/TreeMenu.vue';
import { colors } from '@/constants/theme/colors';
import './styles/filter-item.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterItem',
  props: {
  filterid: {
    type: String,
    default: ''
  },
  translatekey: {
    type: String,
    default: ''
  },
  suggestions: {
    type: Object as any,
    default: [] as any[]
  },
  reset: Boolean,
  resetMe: {
    type: String,
    default: ''
  },
  appliedFilters: {
    type: Array,
    default: [] as []
  }
},
  emits: ['sendFilter', 'addHistoryCat', 'delHistoryCat'],
  setup(__props, { emit }) {

const props = __props;





const getSuggestions = computed(() => props.suggestions[props.filterid]);

const filter = ref([]);
const dateFilter = ref<Moment | null>(null);

const filterCount = ref(0);

const dtcoIds = ref('');

function updateFilter() {
  if (props.filterid === 'last_seen_seconds') {
    const dateChosen = moment(dateFilter.value);
    const seconds = moment().diff(dateChosen, 'seconds');
    emit('sendFilter', props.filterid, seconds);
    filterCount.value = 1;
  } else if (props.filterid === 'dtco_ids') {
    const ids = dtcoIds.value.replace(/ /g, '').split(',');
    emit('sendFilter', props.filterid, ids);
    filterCount.value = ids.length;
  } else if (props.filterid === 'fromto') {
    const m = moment.utc({
      year: dateFilter.value?.year(),
      month: dateFilter.value?.month(),
      day: dateFilter.value?.date(),
      hour: dateFilter.value?.hour(),
      minute: dateFilter.value?.minute(),
      second: 0
    });
    emit('sendFilter', props.filterid, m.unix());
    filterCount.value = 1;
  } else {
    emit('sendFilter', props.filterid, filter.value);
    filterCount.value = filter.value.length;
  }
}

function getToday() {
  return moment().startOf('day');
}

const handleChange = (value: any) => {
  dateFilter.value = value;
  updateFilter();
};

function eventBusAddCat(cat: string) {
  emit('addHistoryCat', cat);
}

function eventBusDelCat(cat: string) {
  emit('delHistoryCat', cat);
}

// Reset specific filter
watch(
  () => props.reset,
  () => {
    filterCount.value = 0;
    filter.value = [];
    dateFilter.value = null;
  }
);

// Conditionnal filter reset
watch(() => props.resetMe, (newValue) => {
  if (newValue === props.filterid) {
    filterCount.value = 0;
    filter.value = [];
    dateFilter.value = null;
  }
});

// Update filter item on bookmark or saved filter load
watch(() => props.appliedFilters, (newFilters) => {
  (newFilters as Record<string, any>[]).forEach((f) => {
    if (props.filterid in f && props.filterid !== 'last_seen_seconds' && props.filterid !== 'fromto') {
      filter.value = f[props.filterid];
      filterCount.value = f[props.filterid].length;
    } else if (props.filterid in f && (props.filterid === 'last_seen_seconds' || props.filterid === 'fromto')) {
      dateFilter.value = null;
      filterCount.value = f[props.filterid].length;
    }
  });
});

return { __sfc: true,emit, props, getSuggestions, filter, dateFilter, filterCount, dtcoIds, updateFilter, getToday, handleChange, eventBusAddCat, eventBusDelCat, DatePicker, TreeMenu, colors }
}

})